import { render, staticRenderFns } from "./IssueProduct.vue?vue&type=template&id=3ad6f6e8&scoped=true&"
import script from "./IssueProduct.vue?vue&type=script&lang=js&"
export * from "./IssueProduct.vue?vue&type=script&lang=js&"
import style0 from "./IssueProduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./IssueProduct.vue?vue&type=style&index=1&id=3ad6f6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6f6e8",
  null
  
)

export default component.exports